<div class="field-time-wrapper">
  <div class="time-ans" *ngIf="!isInput">
    {{timeDisplay}}
  </div>

  <div class="time-input" *ngIf="isInput">
    <timepicker [(ngModel)]="timeInput" (ngModelChange)="onChange()"></timepicker>
  </div>
</div>